module.exports = __webpack_public_path__ + "static/media/logo.4e2b0042.svg";